import { useEffect, useRef } from 'react'
import { Navigate } from 'react-router'

import { useAuth } from '@/shared/contexts/AuthContext'
import { ui } from '@/shared/strings/ui'

export function LogoutAction(): React.ReactElement {
  const { user, logout } = useAuth()
  const calledRef = useRef(false)
  const isJudge = user?.type === 'judge'

  useEffect(() => {
    // Judges must never log out — clearPersistedCache() would wipe their scoring data.
    if (isJudge) return
    if (calledRef.current) return
    calledRef.current = true
    logout()
  }, [logout, isJudge])

  if (isJudge) return <Navigate to="/competition" replace />
  if (!user) return <Navigate to="/login" replace />

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-muted-foreground">{ui.common.loading}</div>
    </div>
  )
}
